module.exports = __webpack_public_path__ + "img/eu.e1bbc871.png";